import React, { useEffect, useRef, useState } from "react";
import Papa from "papaparse";
import "../menu/menu.css";

const CSV_URL ="https://docs.google.com/spreadsheets/d/e/2PACX-1vTw-IEZhNwM3MqYxg--qy3G1_b9c7pokqMYFT9xKBhYTBuQA572ASzbJO8Ok6TAJVLMgGVgqTOeEmi5/pub?gid=0&single=true&output=csv";

export default function Menu() {
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);

  const [menuOpen, setMenuOpen] = useState(false);
  const [expandedMain, setExpandedMain] = useState(null);

  const categoryRefs = useRef({});

  useEffect(() => {
    Papa.parse(CSV_URL, {
      download: true,
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        console.log(results.meta.fields);
        console.log(results.data);

        setMenu(results.data.filter(item => item["Main Category"]));
        setLoading(false);
      },
      error: (err) => {
        console.error(err);
        setLoading(false);
      },
    });
  }, []);

  const grouped = menu.reduce((acc, item) => {

    const main = item["Main Category"]?.trim();
    const sub = item["Sub Category"]?.trim();

    if (!main || !sub) return acc;

    if (!acc[main]) {
      acc[main] = {};
    }

    if (!acc[main][sub]) {
      acc[main][sub] = [];
    }

    acc[main][sub].push(item);

    return acc;

  }, {});

 const scrollToCategory = (key) => {
  setMenuOpen(false);

  setTimeout(() => {
    const element = categoryRefs.current[key];

    if (!element) return;

    const y =
      element.getBoundingClientRect().top +
      window.pageYOffset -
      100; // offset from top

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }, 100);
};
  if (loading) {
    return (
      <div className="menu-page">
        <div className="menu-header">
          <h2>Loading Menu...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="menu-page">

      {/* HEADER */}

      <header className="menu-header">

        <img
          src="/assets/logo.png"
          alt="Vindhu's Kitchen"
          className="logo"
        />

        <h1 className="restaurant-name">
          Vindhu's Kitchen
        </h1>

        <p className="tagline">
          HOME STYLE • HEART STYLE
        </p>

        <p className="restaurant-desc">
          Authentic homemade food prepared fresh every day using
          premium quality ingredients and traditional recipes.
        </p>

        <div className="badge">
          <span></span>
          <p>Fresh • Homemade • Hygienic</p>
        </div>

      </header>

      {/* CATEGORY NAVIGATION */}

      <div className="menu-dropdown">

        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰ Browse Menu
        </button>

        {menuOpen && (

          <div className="dropdown-menu">

            {Object.entries(grouped).map(([mainCategory, subCategories]) => (

              <div key={mainCategory}>

                <div
                  className="dropdown-main"
                  onClick={() =>
                    setExpandedMain(
                      expandedMain === mainCategory
                        ? null
                        : mainCategory
                    )
                  }
                >

                  <span>{mainCategory}</span>

                  <span>
                    {expandedMain === mainCategory ? "▼" : "▶"}
                  </span>

                </div>

                {expandedMain === mainCategory && (

                  <div className="dropdown-sub">

                    {Object.keys(subCategories).map((subCategory) => (

                      <div
                        key={subCategory}
                        className="dropdown-item"
                        onClick={() => {
                          scrollToCategory(
                            `${mainCategory}-${subCategory}`
                          );
                          // setMenuOpen(false);
                        }}
                      >
                        {subCategory}
                      </div>

                    ))}

                  </div>

                )}

              </div>

            ))}

          </div>

        )}

      </div>

      {/* MENU */}

      <section className="menu-content">

  {Object.entries(grouped).map(([mainCategory, subCategories]) => (

    Object.entries(subCategories).map(([subCategory, items]) => (

      <div
        key={`${mainCategory}-${subCategory}`}
        className="category-card"
        ref={(el) =>
          (categoryRefs.current[`${mainCategory}-${subCategory}`] = el)
        }
      >

        <div className="category-header">

          <h2 className="title">
            {subCategory}
          </h2>

        </div>

        <div className="items">

          {items.map((item, index) => (

            <div className="menu-item" key={index}>

              <div className="item-details">

                <h4>{item.Item}</h4>

                {item.Description?.trim() && (
                  <p>{item.Description}</p>
                )}

              </div>

              <div className="price-section">

                <span className="dots"></span>

                <span className="price">
                  ₹{item.Price}
                </span>

              </div>

            </div>

          ))}

        </div>

      </div>

    ))

  ))}

</section>

      {/* FOOTER */}

      <footer className="footer">

        <div className="footer-box">

          <h3>Fresh Ingredients</h3>

          <p>
            Every dish is prepared fresh using
            premium quality ingredients.
          </p>

        </div>

        <div className="footer-box">

          <h3>Opening Hours</h3>

          <p>
            Monday - Sunday
            <br />
            7:00 AM – 10:00 PM
          </p>

        </div>

        <div className="footer-box">

          <h3>Contact</h3>

          <h2>7674901641</h2>

          <p>@vindhuskitchen</p>

        </div>

      </footer>

    </div>
  );
}